import TitleBlock, { TitleBlockWrapper } from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import CardModal, { CardModalContent } from '@anm/components/modals/CardModal';
import { OptionContainer, SelectOptionsContainer, SelectValueContainer } from '@anm/components/select/Select';
import styled from 'styled-components';

export const ModalWrapper = styled(CardModal)`
  ${CardModalContent} {
    padding: 32px 60px 40px;
    max-width: 440px;
  }

  ${TitleBlockWrapper} {
    max-width: 100%;
  }

  ${OptionContainer} > div > div {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  ${SelectValueContainer} {
    min-height: 40px;
    padding: 9px 10px;
    box-sizing: border-box;
    & > div {
      display: flex;
      align-items: center;
      flex-direction: row;
    }

    &:after {
      position: absolute;
      bottom: 0;
      right: 0;
      height: 40px;
    }
  }
`;

export const ModalTitle = styled(TitleBlock)`
  text-align: center;
`;

export const InputsWrapper = styled.div`
  margin: 16px 0 24px 0;
`;

export const FieldWrapper = styled.div`
  position: relative;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  &:first-child {
    ${SelectValueContainer} {
      padding: 3px 4px;
    }

    ${SelectOptionsContainer} {
      overflow: auto;
      max-height: 200px;
    }
  }
`;

export const SelectLabel = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #919eaa;
  display: block;
  margin-bottom: 1px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const CancelButton = styled(Button)`
  margin-right: 11px;
  min-width: 117px;
  min-height: 50px;
  line-height: 1;
  border: 2px solid rgba(1, 83, 130, 0.2);
  border-radius: 5px;
  color: #292a2b;

  &:hover {
    background-color: #e0e4ed;
    color: #292a2b;
  }
`;

export const SaveButton = styled(ButtonLoader)`
  min-width: 170px;
  min-height: 50px;
  line-height: 1;
`;
